"use strict";

var _taggedTemplateLiteral = require("/root/website/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.media = exports.sizes = void 0;

var _stylitas = require("@creditas/stylitas");

var sizes = {
  xs: 320,
  sm: 360,
  md: 1024,
  lg: 1366,
  xl: 1920
};
exports.sizes = sizes;
var media = Object.keys(sizes).reduce(function (acc, label) {
  acc[label] = function () {
    return (0, _stylitas.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    @media (min-width: ", "em) {\n      ", "\n    }\n  "])), sizes[label] / 16, (0, _stylitas.css).apply(void 0, arguments));
  };

  return acc;
}, {});
exports.media = media;